module.exports = __webpack_public_path__ + "static/media/Vikram-Khanna.6795db01.jpg";